// eslint-disable-next-line
export default {
   'settings.tittle': 'Configuración: Correo estado de cuenta',
   'settings.tryon': 'Vista previa',
   'settings.send.tryon': 'Enviar prueba',
   'settings.button.send': 'Enviar',
   'settings.button.cancel': 'Cancelar',
   'settings.send.tryon.for': 'Enviar a:',
   'settings.send.tryon.for.textHelp': 'usa comas para separar los correos electrónicos',
   'settings.send.tryon.for.placeholder':'Ej.: juan@revenatium.com. maria@revenatium.com',
   'settings.tryon.subject': 'Asunto',
   'settings.accountStatement.layout.tittle': 'Estado de Cuenta {name}',
   'settings.accountStatement.layout.greetings': 'Apreciable {name}',
   'settings.accountStatement.layout.welcome': '¡Esperamos que se encuentre disfrutando de los beneficios de {name}! Con gusto compartimos el resumen de su saldo en puntos correspondiente al período del {period}.',
   'settings.accountStatement.layout.pointsAcumulated': 'Puntos acumulados este mes',
   'settings.accountStatement.layout.pointsRedeemed': 'Puntos redimidos este mes',
   'settings.accountStatement.layout.totalPoints': 'Total puntos disponibles',
   'settings.accountStatement.layout.menssage': 'Disfrute de puntos y ofertas.',
   'settings.accountStatement.layout.benefits1': 'Hospedaje con tarifas especiales para socios.',
   'settings.accountStatement.layout.benefits2': 'Certificados en alimentos y bebidas.',
   'settings.accountStatement.layout.benefits3': 'Certificados en Spa.',
   'settings.accountStatement.layout.button1': 'Acceder a su cuenta',
   'settings.accountStatement.layout.button2': 'Contáctenos',
   'settings.accountStatement.layout.farewell': 'Gracias por su preferencia, esperamos pronto recibirle en casa.',
   'settings.accountStatement.layout.team': 'El equipo de Brisas Rewards.',
   'settings.accountStatement.layout.terms': 'Aplican Términos y condiciones exclusivos del programa que podrá consultar en {link}.',
   'settings.accountStatement.layout.terms&conditions': ' {name} tratará sus datos personales para: (i) proveerle los servicios que solicita o contrata con nosotros; (ii) elaborar convenios de tarifas preferenciales; (iii)  evaluar la calidad de nuestro servicio; y (iv) fines publicitarios, mercadotécnicos.',
   'settings.form.required.loyaltyPlanId': 'El campo Plan de lealtad es requerido',
   'settings.form.loyaltyPlanId': 'Programa',
   'settings.form.loyaltyPlanId.helpText': 'Selecciona un plan de lealtad para editar el banner',
   'settings.form.user.tittle': 'ID usuario (opcional)',
   'settings.form.showbanner.tittle': 'Mostrar banner',
   'settings.form.image.required': 'El campo Imagen es requerido',
   'settings.form.image.tittle': 'Imagen',
   'settings.form.showlink.tittle': 'Agregar link',
      'settings.form.link.validate': 'Formato incorrecto para un link',
   'settings.form.link.tittle': 'URL',
   'settings.form.save.tittle': 'Guardar',
   'settings.form.cancel.tittle': 'Cancelar',
   'settings.submit.success': 'El banner fue agregado al estado de cuenta correctamente',
   'settings.submit.success.update': 'El banner fue actualizado correctamente',
   'settings.submit.error': 'El banner del estado de cuenta no se realizo correctamente',
   'settings.tryon.success': 'El correo fue enviado correctamente',
   'settings.tryon.error': 'El correo no se pudo enviar, verifica los correos electrónicos ingresados',
   'settings.send.tryon.for.tittle': 'Socio : {name}',
   'settings.send.tryon.for.tittle.default': 'default',
   'settings.form.tryon.for.externalId': 'ExternalId: {externalId}',
   'settings.form.showbanner.required': 'Se necesita agregar una Imagen para el banner',
   'settings.layout.urlTerms': 'No es posible editar el correo de estado de cuenta en este momento. ya que el envio está a punto de realizarse. Le edición estará disponible nuevamente en {hours} horas.',
}